import { render, staticRenderFns } from "./AsterWhatsapp.vue?vue&type=template&id=dfdfe852&"
import script from "./AsterWhatsapp.vue?vue&type=script&lang=js&"
export * from "./AsterWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./AsterWhatsapp.vue?vue&type=style&index=0&id=dfdfe852&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports